export default __webpack_public_path__ + "static/media/Slide44.3651ba49.PNG";